import React from "react";

import Barriles from "./barriles";
import Main from "./index";

import { Switch, Route, Redirect } from "react-router-dom";

const baseUrl = "/secure/config/migracion";

/**
 * Este componente controla dos funcionalidades
 *   a) Conecta del estado/datos con los componentes
 *   b) Maneja las rutas dentro de la pantalla actual
 *
 * De paso el Loading lo controla este componente
 *
 * OBS:   Tener en cuenta el prefijo de las rutas, acá si llego porque el prefijo
 *      /admin/tanque nos llevo a este controlador.
 *        Toda ruta interna deberia tener ese prefijo
 */
export default class Connector extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    render() {
        return (
            <>
                <Switch>
                    <Route
                        path={baseUrl + "/barriles"}
                        render={(routeProps) => <Barriles baseUrl={baseUrl} {...this.props} {...routeProps} />}
                    />
                    <Route
                        path={baseUrl + "/"}
                        render={(routeProps) => <Main baseUrl={baseUrl} {...this.props} {...routeProps} />}
                    />
                    <Redirect to={"/"} />
                </Switch>
            </>
        );
    }
}
